import { QueryClient } from '@tanstack/react-query';

interface ErrorWithStatus {
  status?: number;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        const err = error as ErrorWithStatus;
        if (err?.status && err.status >= 400 && err.status < 500) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: (failureCount, error: unknown) => {
        const err = error as ErrorWithStatus;
        if (err?.status && err.status >= 400 && err.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

export default queryClient;
